/** 光标主色 */
export const cursorColor = "#ff7a57";
/** 光标主色, RGB 版本 */
export const cursorColorRGB = "253, 105, 83";
